export interface BaseCalendarSettings {
  events: EventItem[];
  featuredEvent?: FeaturedEvent;
  maxItems?: number;
  featuredId?: number;
  filterOptions?: string[];
  typeOptions?: string[];
  initialDate: string;
  calendarPageUrl?: string;
  filterName?: string;
}

export interface EventItem {
  id: number;
  title: string;
  subtitle: string;
	description: string;
  summary: string;
  url: string;
  thumbnail: string;
  startDate: string;
  endDate: string;
  start: string;
  end: string;
  hideTime: boolean;
  timezone: string;
  categoryName: string;
	locale: string;
  eventTypeName: string;
}

export interface FeaturedEvent {
  id: number;
  title: string;
  subtitle: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  hideTime: boolean;
  timezone: string;
  thumbnail: string;
  description: string;
  summary: string;
  url: string;
}
export interface FilterGroup {
  key: string;
  label: string;
  options: FilterOption[];
  selectedValues: string[];
}

export interface EventCalendarSettings extends BaseCalendarSettings {
  filters: FilterGroup[];
}

export const All = 'All';
export interface FilterOption {
	filterKey: string,
	filterValue: string,
	filterDisplayValue?: string,
}
